import React, { useEffect } from "react";

import Nav from "components/Nav/Nav";
import Hero from "components/Hero";
import Features from "components/Features";
import Pricing from "components/Pricing";
import Footer from "components/Footer";
import AppShowcase from "components/AppShowcase";
import Testimonials from "components/Testimonials";
import CallToAction from "components/CallToAction";

function LandingPage() {
  useEffect(() => {
    // Add animation classes on scroll
    const observerOptions = {
      threshold: 0.1,
      rootMargin: "0px 0px -100px 0px",
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("animate-in");
        }
      });
    }, observerOptions);

    const animatedElements = document.querySelectorAll(".animate-on-scroll");
    animatedElements.forEach((el) => observer.observe(el));

    return () => {
      animatedElements.forEach((el) => observer.unobserve(el));
    };
  }, []);

  return (
    <>
      <style>
        {`
          .animate-on-scroll {
            opacity: 0;
            transform: translateY(30px);
            transition: opacity 0.6s ease-out, transform 0.6s ease-out;
          }

          .animate-on-scroll.animate-in {
            opacity: 1;
            transform: translateY(0);
          }

          .hero-section {
            animation: fadeIn 1s ease-in;
          }

          @keyframes fadeIn {
            from {
              opacity: 0;
            }
            to {
              opacity: 1;
            }
          }

          .feature-card {
            transition: transform 0.3s ease, box-shadow 0.3s ease;
          }

          .feature-card:hover {
            transform: translateY(-10px);
            box-shadow: 0 10px 30px rgba(0,0,0,0.1);
          }

          .pulse-animation {
            animation: pulse 2s infinite;
          }

          @keyframes pulse {
            0% {
              transform: scale(1);
            }
            50% {
              transform: scale(1.05);
            }
            100% {
              transform: scale(1);
            }
          }

          .slide-in-left {
            animation: slideInLeft 0.8s ease-out;
          }

          @keyframes slideInLeft {
            from {
              opacity: 0;
              transform: translateX(-50px);
            }
            to {
              opacity: 1;
              transform: translateX(0);
            }
          }

          .slide-in-right {
            animation: slideInRight 0.8s ease-out;
          }

          @keyframes slideInRight {
            from {
              opacity: 0;
              transform: translateX(50px);
            }
            to {
              opacity: 1;
              transform: translateX(0);
            }
          }
        `}
      </style>

      <Nav />

      <Hero />

      <AppShowcase />

      <Features />

      <Testimonials />

      <Pricing />

      <CallToAction />

      <Footer />
    </>
  );
}

export default LandingPage;
